export default "__VITE_ASSET__fc636aaf__"